import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API } from '@const'
import * as utils from '@utils'
import { Decimal } from 'decimal.js'
import { Grid, Divider, Typography, Button } from '@material-ui/core'
import GameRoundResultPage from '../pages/game-round-result-page'
import ComponentDialog from '@dialogs/component-dialog'
import { Table, Icon } from 'antd'

class BetRecordTable extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'BetRecordTable', options)
        }
        this.handleTableChange = this.handleTableChange.bind(this)
    }

    state = {
        currency: '',
        list: [],
        gameList: [],
        dataLength: 0,
        sumList: [],
        loading: false,
        currentPage: 1,
        pageLimit: 10,
        total: 0,
        pageSizeOptions: ['10','30','50','100'],
        sort_field: '',
        sort_order: '',
        showChildList: false,
        keyword_field: 'all',
        pf_sub_pf_id: '',
        pf_Id: ''
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps?.currency && (prevProps.currency !== prevState.currency)) {
            this.setState({
                currency: prevProps.currency
            })
        }
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }
    
    sumTableColumns = [
        {
            title: utils.t('totalBet', 'BetRecordTable'),
            dataIndex: 'totalBet',
            align: 'center',
            render: (text) => {
                const display = utils.currencyTrans(text, this.state.currency)
                return display
                
            }
        },
        {
            title: utils.t('totalBetValid', 'BetRecordTable'),
            dataIndex: 'totalBetValid',
            align: 'center',
            render: (text) => {
                const display = utils.currencyTrans(text, this.state.currency)
                return display
                
            }
        },
        {
            title: utils.t('totalOperatorProfit', 'BetRecordTable'),
            dataIndex: 'totalOperatorProfit',
            align: 'center',
            render: (text) => {
                const display = utils.currencyTrans(text, this.state.currency)
                const fontColor = text < 0 ? 'red' : ''
                return <div style={{ color: fontColor }}>{display}</div>
                
            }
        },
        {
            title: utils.t('totalCount', 'BetRecordTable'),
            dataIndex: 'totalCount',
            align: 'center',
        },
    ]

    columns = [
        {
            title: (
                <div className={this.props.classes.showChildListList}
                    onClick={() => {
                        this.showChildListList()
                    }}>
                    <Icon
                        className={this.props.classes.showChildIcon}
                        type={'column-height'}
                    />
                    {utils.t('round_end_at', 'BetRecordTable')}
                </div>
            ),
            width: 200,
            dataIndex: 'round_end_at',
            align: 'center',
            render: (text) => {
                return utils.unixToDateTime(text)
            },
        },
        {
            title: utils.t('bet_record_id', 'BetRecordTable'),
            dataIndex: 'bet_record_id',
            align: 'center',
            render: (text, record) => {
                return (
                    <a
                        href="/#"
                        onClick={(e) => {
                            e.preventDefault()
                            this.setState({ loading: true })
                            utils.apiRequest(
                                'get',
                                API.BET_DETAIL + '/' + record.bet_record_id,
                                {
                                    lang: utils.getCurrentLang(),
                                },
                                (data) => {
                                    const currency = utils.getPfSubPfCurrency(record['pf_sub_pf_id'])
                                    const query = `&timezone=-0400&is_cms=yes&currency=${currency}&currency_rate=${1 / utils.getCurrencyRate(currency)}`

                                    window.open(data.url + query)
                                    this.setState({ loading: false })
                                },
                                (_error) => {
                                    this.setState({ loading: false })
                                }
                            )
                        }}>
                        {text}
                    </a>
                )
            },
            sorter: true
        },
        {
            title: utils.t('round_id', 'BetRecordTable'),
            dataIndex: 'round_id',
            align: 'center',
            render: (text, record) => {
                return text ? (
                    <Button
                        className={this.props.classes.linkButton}
                        onClick={() =>
                            this.compDialog.OpenDialog(
                                this.t('GameRoundResultPage'),
                                <GameRoundResultPage
                                    compDialogArgs={{
                                        dateUnit: 'minute',
                                        searchType: 'round',
                                        roundID: record['round_id'],
                                    }}></GameRoundResultPage>
                            )
                        }>
                        {text}
                    </Button>
                ) : ''
            },
            sorter: true
        },
        {
            title: utils.t('game_name', 'BetRecordTable'),
            dataIndex: 'game_code',
            align: 'center',
            render: (text) => {
                return text ? utils.t(`GameName.${text}`) : ''
            },
            sorter: true
        },
        {
            title: utils.t('result', 'GameRoundResultPage'),
            dataIndex: 'bet_status',
            align: 'center',
            render: (text) => {
                if (text) {
                    const result = utils.t(`BetStatus.${text}`)
                    const fontColor = /輸|Lose|输/.test(result) ? 'red' : ''
                    return <div style={{ color: fontColor }}>{result}</div>
                }
                return '' 
            },
        },
        {
            title: utils.t('bet_area', 'GameRoundResultPage'),
            dataIndex: 'bet_area',
            align: 'center',
            width: 120,
        },
        {
            title: utils.t('bet', 'GameRoundResultPage'),
            dataIndex: 'bet',
            align: 'center',
            render: (text) => {
                if (!isNaN(text)) {
                    const display = utils.currencyTrans(text, this.state.currency)
                    return display
                }
                return ''
            },
            sorter: true
        },
        {
            title: utils.t('bet_valid', 'GameRoundResultPage'),
            dataIndex: 'bet_valid',
            align: 'center',
            render: (text) => {
                if (!isNaN(text)) {
                    const display = utils.currencyTrans(text, this.state.currency)
                    return display
                }
                return ''
            },
            sorter: true
        },
        {
            title: utils.t('operator_profit', 'GameRoundResultPage'),
            dataIndex: 'operator_profit',
            align: 'center',
            render: (text) => {
                if (!isNaN(text)) {
                    const display = utils.currencyTrans(text, this.state.currency)
                    const fontColor = text < 0 ? 'red' : ''
                    return <div style={{ color: fontColor }}>{display}</div>
                } 
                return ''
            },
            sorter: true
        },
        {
            title: utils.t('tax', 'GameRoundResultPage'),
            dataIndex: 'tax',
            align: 'center',
            render: (text) => {
                if (!isNaN(text)) {
                    const display = utils.currencyTrans(text, this.state.currency)
                    return display
                }
                return ''
            }
        },
        {
            title: utils.t('common_result', 'GameRoundResultPage'),
            dataIndex: 'common_result',
            align: 'center',
            width: 150,
            render: (text, record, index) => {
                /** 需另外處理開獎結果 */
                if (utils.IsSupportSplitBetRecord(record.game_code)) {
                    /** 已有開獎結果 */
                    if (record.roundResults) {
                        const commonResult = JSON.parse(record.roundResults)
                        return utils.GetBetTypeGameCommonResultDisplay(record.game_code, commonResult, true)
                    } else {
                        return (
                            <a
                                href="/#"
                                onClick={(e) => {
                                    e.preventDefault()
                                     /** 使用api取得開獎結果 */
                                    utils.apiRequest('get', API.BET_RECORD_LIST + '/round_result/' + record.round_id, {}, (data) => {
                                        const newList = [...this.state.list]
                                        newList[index].roundResults = data.common_result
                                        /** 將開獎結果組入相對應資料後更新list觸發table刷新 */
                                        this.setState({list: newList})
                                    })
                                }}>
                                {this.t('showResults')}
                            </a>
                        )
                    }
                }

                return ''
            }
        },
    ]

    gameColumns = [
        {
            title: utils.t('game_name', 'BetRecordTable'),
            dataIndex: 'game_code',
            align: 'center',
            render: (text) => {
                return text ? utils.t(`GameName.${text}`) : ''
            },
        },
        {
            title: utils.t('betAmount'),
            dataIndex: 'bet_amount',
            align: 'center',
            render: (text, record) => {
                return text ? (
                    <Button
                        className={this.props.classes.linkButton}
                        onClick={() =>
                            this.compDialog.OpenDialog(
                                this.t('GameRoundResultPage'),
                                <GameRoundResultPage
                                    compDialogArgs={{
                                        dateUnit: 'minute',
                                        searchType: 'date',
                                        gameCode: record['game_code'],
                                        startDate: this.state.start_date,
                                        endDate: this.state.end_date,
                                        purchase_method: 0,
                                        pfId: this.state.pf_Id,
                                        pfSubPfId: this.state.pf_sub_pf_id,
                                        gameMaker: 'all',
                                        displayGameTypeCode: 'all',
                                        pfAccount: this.state.pf_account
                                    }}>
                                </GameRoundResultPage>
                            )
                        }>
                        {text}
                    </Button>
                ) : '0'
            },
            sorter: true
        },
        {
            title: utils.t('bet'),
            dataIndex: 'bet',
            align: 'center',
            render: (text) => {
                if (!isNaN(text)) {
                    const display = utils.currencyTrans(text, this.state.currency)
                    return display
                }
                return ''
            },
            sorter: true
        },
        {
            title: utils.t('buyFreeGameAmount'),
            dataIndex: 'buy_free_game_amount',
            align: 'center',
            render: (text, record) => {
                return text ? (
                    <Button
                        className={this.props.classes.linkButton}
                        onClick={() =>
                            this.compDialog.OpenDialog(
                                this.t('GameRoundResultPage'),
                                <GameRoundResultPage
                                    compDialogArgs={{
                                        dateUnit: 'minute',
                                        searchType: 'date',
                                        gameCode: record['game_code'],
                                        startDate: this.state.start_date,
                                        endDate: this.state.end_date,
                                        purchase_method: 1,
                                        pfId: this.state.pf_Id,
                                        pfSubPfId: this.state.pf_sub_pf_id,
                                        gameMaker: 'all',
                                        displayGameTypeCode: 'all',
                                        pfAccount: this.state.pf_account,
                                    }}>
                                </GameRoundResultPage>
                            )
                        }>
                        {text}
                    </Button>
                ) : '0'
            },
            sorter: true
        },
        {
            title: utils.t('betValid'),
            dataIndex: 'bet_valid',
            align: 'center',
            render: (text) => {
                if (!isNaN(text)) {
                    const display = utils.currencyTrans(text, this.state.currency)
                    return display
                }
                return ''
            },
            sorter: true
        },
        {
            title: utils.t('operatorProfit'),
            dataIndex: 'profit',
            align: 'center',
            render: (text) => {
                if (!isNaN(text)) {
                    const profit = text*-1
                    const display = utils.currencyTrans(profit, this.state.currency)
                    const fontColor = profit < 0 ? 'red' : ''
                    return <div style={{ color: fontColor }}>{display}</div>
                } 
                return ''
            },
            sorter: true
        },
        {
            title: utils.t('tax'),
            dataIndex: 'tax',
            align: 'center',
        },
        {
            title: utils.t('profitRate'),
            dataIndex: 'profit_rate',
            align: 'center',
            render: (text) => {
                return this.handleNumberRender(text)
            }
        },
        {
            title: 'RTP',
            dataIndex: 'rtp',
            align: 'center',
            render: (text) => {
                return this.handleNumberRender(text)
            },
            sorter: true
        },
    ]

    SetData(data) {
        this.setState({
            list: data,
            currentPage: 1,
            dataLength: data.length,
            gameList: data
        }, this.calculateTotal())
    }

    queryData = () => {
        this.setState({ loading: true })
        const { pf_account, start_date, end_date, lang, timezone, currentPage, pageLimit, keyword_field, keyword } = this.state
        const params = {
            pf_account,
            start_date,
            end_date,
            lang,
            timezone,
            page: currentPage,
            limit: pageLimit,
        }
   
        if (this.state.sort_field !== '' && this.state.sort_order !== '') {
            const sortParams = {
                "ascend": 'ASC',
                "descend": 'DESC'
            }
            
            params.sort_field = this.state.sort_field
            params.sort_order = sortParams[this.state.sort_order]

            // 特規處理區
            if (this.state.sort_field === 'bet_record_id') { 
                params.sort_field = 'record_id'
            }

            if (this.state.sort_field === 'operator_profit') {
                params.sort_field = 'profit'
                if (sortParams[this.state.sort_order] === sortParams.ascend) { // 派彩查看角度為公司面所以升降序需要相反
                    params.sort_order = sortParams.descend
                } else {
                    params.sort_order = sortParams.ascend
                }
            }
        }

        if (this.state.keyword_field !== 'all') {
            params.keyword_field = keyword_field
            params.keyword = keyword
        }

        utils.apiRequest(
            'get',
            API.BET_RECORD_LIST,
            params,
            ({data, page}) => {
                const betRecordList = data['bet_record_list']
                
                // 直接輸出相對應結果
                const gameCodeList = ['GarudaGod', 'AviatorX', 'Aviator']

                // Split bet area type game
                const parsedData = []
                betRecordList.forEach((elem) => {
                    elem['operator_profit'] = -elem['profit']
                    const temp = []
                    if (utils.IsSupportSplitBetRecord(elem.game_code)) {
                        const result = JSON.parse(elem.result)

                        if (elem.game_code === 'ColorPlate' && !result['area_profit']) {
                            temp.push(elem)
                        } else if (gameCodeList.includes(elem.game_code)) {
                            elem.roundResults = elem.result
                            const detail = {
                                ...elem
                            }
                            const betArea = JSON.parse(elem.result).OddsFlyout.reduce((all, cur)=>{
                                if (cur.has_bet) {
                                    if (cur?.is_extra_bet) {
                                        all.push(`${cur.odds_flyout}x (★${cur.extra_multiplier}x)`)
                                    } else {
                                        all.push(`${cur.odds_flyout}x`)
                                    }
                                } else {
                                    all.push('0x')
                                }
                                return all
                            }, [])
                            detail.bet_area = betArea.join(' - ')
                            temp.push(detail)
                        } else {
                            const parents = {
                                ...elem,
                                children: []
                            }
                            result['bet_status'].forEach((value, idx) => {
                                const profit = result['per_area_profit'] ? result['per_area_profit'][idx] : result['area_profit'][idx]
                                if (value > 0) {
                                    let isPeace = false
                                    if (elem.game_code === 'ShaiZiSanGong' || elem.game_code === 'DragonTiger') {
                                        isPeace = Number(new Decimal(value).add(new Decimal(profit).mul(2))) === 0
                                    } else {
                                        isPeace = profit === 0
                                    }
                                    const detail = {
                                        bet: value,
                                        bet_valid: isPeace ? utils.handleBetValid(elem.game_code, value, profit) : value,
                                        profit: isPeace ? 0 : profit,
                                        operator_profit: -profit,
                                        bet_area: utils.GetBetTypeGameAreaDisplay(elem.game_code, idx),
                                        bet_status: isPeace ? 3 : profit > 0 ? 1 : 2, // "1": "赢", "2": "输", "3": "和"
                                        id: `${elem.bet_record_id}-child-${idx}`
                                    }
                                    /** 注單結果 */
                                    if (Number(elem.bet_status) === 5 || Number(elem.bet_status) === 4) {
                                        detail.bet_status = elem.bet_status
                                        detail.bet_valid = 0
                                        detail.profit = 0
                                        detail.operator_profit = 0
                                    }
                                    if (elem.game_code === 'ColorGame' && result['jackpot_info'] && detail.operator_profit < 0) {
                                        /** ColorGame 壓中 Bonus */
                                        const profitAddBonus = new Decimal(profit).add(result['jackpot_info'].money)
                                        detail.operator_profit = -profitAddBonus
                                    }
                                    parents.children.push(detail)
                                }
                            })
                            if (elem.game_code === 'CyberpunkColorDisc' && result.jackpot_info && Number(result.jackpot_info?.money) > 0) {
                                const jackpot_info = {
                                    bet: '',
                                    bet_valid: '',
                                    profit: result['jackpot_info'].money,
                                    operator_profit: `-${result['jackpot_info'].money}`,
                                    bet_area: `JACKPOT(${utils.GetBetTypeGameAreaDisplay(elem.game_code, Number(result['jackpot_area']) + 6)})`,
                                    bet_status: 1,
                                    id: `${elem.bet_record_id}-child-JACKPOT_PAYOUT`
                                }
                                parents.children.push(jackpot_info)
                            }
                            delete parents.bet_status
                            temp.push(parents)
                        }
                    } else {
                        temp.push(elem)
                    }

                    parsedData.push(...temp)
                })

                parsedData.forEach((item, index) => {
                    item.id = `${index*this.state.currentPage}--${item.round_id}`

                })

                this.setState({
                    list: parsedData,
                    dataLength: page.count,
                    loading: false,
                })
                /** 注單總計 */
                const sumList = [
                    {
                        totalBet: data['total_bet'],
                        totalBetValid: data['total_bet_valid'],
                        totalOperatorProfit: data['total_profit'] ? -data['total_profit'] : 0,
                        totalCount: data['total_rows'],
                        id: 1
                    }
                ]
                this.calculateTotal(parsedData, sumList)
            },
            (_err) => {
                this.setState({
                    list: [],
                    dataLength: 0,
                    loading: false
                })
                this.calculateTotal()
            }
        )
    }

    queryDataByGame = () => {
        this.setState({ loading: true })
        const { pf_account, start_date, end_date, timezone, currentPage, pageLimit, pf_sub_pf_id } = this.state
        const params = {
            pf_sub_pf_id,
            pf_account,
            start_date: utils.datetimeToUnix_startOf(start_date, 'minute'),
            end_date: utils.datetimeToUnix_endOf(end_date, 'minute'),
            timezone,
            page: currentPage,
            limit: pageLimit,
        }
   
        if (this.state.sort_field !== '' && this.state.sort_order !== '') {
            const sortParams = {
                "ascend": 'ASC',
                "descend": 'DESC'
            }
            
            params.sort_field = this.state.sort_field
            params.sort_order = sortParams[this.state.sort_order]

            if (this.state.sort_field === 'profit') {
                if (sortParams[this.state.sort_order] === sortParams.ascend) { // 派彩查看角度為公司面所以升降序需要相反
                    params.sort_order = sortParams.descend
                } else {
                    params.sort_order = sortParams.ascend
                }
            }
            
        }

        utils.apiRequest(
            'get',
            API.BET_RECORD_LIST_BY_GAME,
            params,
            ({data, page}) => {
                this.setState({
                    gameList: data.bet_record_sum,
                    dataLength: page.count,
                    loading: false,
                })
                /** 注單總計 */
                const sumList = [
                    {
                        totalBet: data['total_bet'],
                        totalBetValid: data['total_bet_valid'],
                        totalOperatorProfit: data['total_profit'] ? -data['total_profit'] : 0,
                        totalCount: data['total_rows'],
                        id: 1
                    }
                ]
                this.calculateTotal([], sumList)
            },
            (_err) => {
                this.setState({
                    list: [],
                    dataLength: 0,
                    loading: false
                })
                this.calculateTotal()
            }
        )
    }

    calculateTotal = (data, sumList) => {
        if (data) {
            this.setState({sumList: sumList})
        } else {
            const defaultSum = [{
                totalBet: 0,
                totalBetValid: 0,
                totalOperatorProfit: 0,
                totalCount: 0,
                id: 1
            }]
            this.setState({sumList: defaultSum})
        }
    }

    /** submit */
    handleSearch(queryParam) {
        this.setState({
            ...queryParam,
            currentPage: 1,
            list: [],
            gameList: []
        }, () => {
            this.state.keyword_field === 'game_overview' ? this.queryDataByGame() : this.queryData()
        })
    }

    /** change page / limit */
    handlePageChange(page, limit) {
        this.setState({
            currentPage: page,
            pageLimit: limit
        }, () => {
            this.state.keyword_field === 'game_overview' ? this.queryDataByGame() : this.queryData()
        })
    }
    
    handleTableChange(pagination, _filters, sorter) {
        const sort = (field, order) => {
            this.setState({
                sort_field: field,
                sort_order: order,
                pageLimit: pagination.pageSize
            })
        }
        sorter.order ? sort(sorter.field, sorter.order) : sort('', '')
    }

    showChildListList() {
        const childClass = this.state.showChildList ? 'ant-table-row-expanded' : 'ant-table-row-collapsed'
        const list = Array.from(document.getElementsByClassName(childClass))
        if (Array.isArray(list) && list.length > 0) {
            list.forEach((element) => {
                element.click()
            })
            this.setState({
                showChildList: !this.state.showChildList
            })
        }
    }

    handleNumberRender(display) {
        if (typeof display !== 'number') {
            return null
        }

        const decimal = this.props.auth.isCompleteDecimal ? 6 : 2
        const number = display * 100; // 因為後端傳來是小數點, 所以先轉乘百分比在取小數點後兩位
        return <div>{`${utils.getDecimalPlaces(number, decimal)}%`}</div>
    }

    render() {
        return (
            <Grid container spacing={2} >
                    <Grid item xs={6}>
                        <Typography variant="h6">{this.t('total')}</Typography>
                        <Table
                            className="bet-record-table"
                            size="small"
                            loading={this.state.loading}
                            columns={this.sumTableColumns}
                            dataSource={this.state.sumList}
                            bordered
                            rowKey="id"
                            locale={{
                                emptyText: ''
                            }}
                            pagination={false}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        {this.state.keyword_field !== 'game_overview' && <Table
                            className="bet-record-table"
                            size="small"
                            loading={this.state.loading}
                            columns={this.columns}
                            dataSource={this.state.list}
                            bordered
                            rowKey="id"
                            locale={{
                                emptyText: utils.t('noRecordsToDisplay', 'Table')
                            }}
                            pagination={{
                                current: this.state.currentPage,
                                pageSize: this.state.pageLimit,
                                total: this.state.dataLength,
                                showTotal: () => ``,
                                onChange: (nextPage, currentPageSize) => {
                                    this.handlePageChange(nextPage, currentPageSize)
                                },
                                onShowSizeChange: (currentPage, nextSize) => {
                                    this.handlePageChange(1, nextSize)
                                },
                                showSizeChanger: true, // 允许改变每页显示的条数
                                pageSizeOptions: this.state.pageSizeOptions, // 每页显示的条数选项
                            }}
                            onChange={this.handleTableChange} // 排序 篩選 資料變更 都會觸發這裡 目前用來 call 排序 api
                        />}
                        {this.state.keyword_field === 'game_overview' && <Table
                            className="bet-record-table"
                            size="small"
                            loading={this.state.loading}
                            columns={this.gameColumns}
                            dataSource={this.state.gameList}
                            bordered
                            rowKey="game_code"
                            locale={{
                                emptyText: utils.t('noRecordsToDisplay', 'Table')
                            }}
                            pagination={{
                                current: this.state.currentPage,
                                pageSize: this.state.pageLimit,
                                total: this.state.dataLength,
                                showTotal: () => ``,
                                onChange: (nextPage, currentPageSize) => {
                                    this.handlePageChange(nextPage, currentPageSize)
                                },
                                onShowSizeChange: (currentPage, nextSize) => {
                                    this.handlePageChange(1, nextSize)
                                },
                                showSizeChanger: true, // 允许改变每页显示的条数
                                pageSizeOptions: this.state.pageSizeOptions, // 每页显示的条数选项
                            }}
                            onChange={this.handleTableChange} // 排序 篩選 資料變更 都會觸發這裡 目前用來 call 排序 api
                        />}
                    </Grid>
                    <ComponentDialog onRef={(ref) => (this.compDialog = ref)}></ComponentDialog>
            </Grid>
        )
    }
}

const styles = (_theme) => {
    return {
        linkButton: {
            background: 'none!important',
            border: 'none',
            padding: '0!important',
            color: '#1890ff',
            textDecoration: 'none',
            cursor: 'pointer',
            userSelect: 'text',
        },
        show: {
            display: 'block'
        },
        hide: {
            display: 'none'
        },
        showChildListList: {
            position: 'relative'
        },
        showChildIcon: {
            position: 'absolute',
            left: '-20px',
            top: '0.5px',
            border: '1px',
            borderStyle: 'solid',
            cursor: 'pointer'
        }
    }
}

BetRecordTable.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    dataService: PropTypes.object,
    currency: PropTypes.string,
    auth: PropTypes.object,
}

export default hoc(styles)(BetRecordTable)
